<template>
  <v-expansion-panels
    v-model="isOpen"
    multiple
    flat
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row align="center" justify="end"
               class="px-3 deep-purple--text lighten-3 font-weight-bold">
          {{ $t('common.filter') }}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          color="deep-purple lighten-3"
          elevation="6"
          class="pa-2"
        >
          <v-form>
            <v-row align="center" justify="space-between">
              <v-col class="d-flex flex-row align-items-center justify-content-start" cols="12">
                <v-col cols="3">
                  <CountryInput
                    :value="value.country"
                    :placeholder="$t('students.country')"
                    :countries="countries"
                    @input="(val) => manageInput('country', val)"
                    hide-details
                    single-line
                    :filled="false"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    placeholder="Colegio"
                    flat
                    solo
                    light
                    rounded
                    dense
                    :items="schoolList"
                    item-text="text"
                    item-value="value"
                    :value="value.school_id"
                    @input="(val) => manageInput('school_id', val)"
                    color="white"
                    single-line
                    hide-details
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="Nombre"
                    solo
                    dense
                    flat
                    light
                    rounded
                    hide-details
                    :value="value.firstname"
                    @input="(val) => manageInput('firstname', val)"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="Apellidos"
                    solo
                    dense
                    flat
                    light
                    rounded
                    hide-details
                    :value="value.lastname"
                    @input="(val) => manageInput('lastname', val)"
                  />
                </v-col>
              </v-col>

              <v-col class="d-flex flex-row align-items-center justify-content-start" cols="12">
                <v-col cols="12" md="3">
                  <v-text-field
                    placeholder="DNI"
                    solo
                    dense
                    flat
                    light
                    rounded
                    hide-details
                    :value="value.dni"
                    @input="(val) => manageInput('dni', val)"
                  />
                </v-col>

                <v-col cols="6"
                       class="d-flex flex-column flex-md-row align-items-center justify-content-start">
                  <span>Estatus:</span>
                  <v-btn-toggle :value="value.active" @change="(val) => manageInput('active', val)" dense
                                class="mx-3" rounded>
                    <v-btn :value="true">Activo</v-btn>
                    <v-btn :value="false">Inactivo</v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-col>
            </v-row>

            <v-row class="px-2">
              <v-col cols="12"
                     class="d-flex flex-column justify-content-end flex-md-row ml-auto px-2">
                <v-btn
                  text
                  color="white"
                  class="text-decoration-underline"
                  small
                  rounded
                  @click="clearFilter"
                >
                  Limpiar
                </v-btn>
                <v-btn
                  class="search-btn"
                  outlined
                  rounded
                  small
                  @click="search"
                >
                  Buscar 🔍
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import countryService from '../../../services/country.service';
import schoolService from '../../../services/school.service';
import { COUNTRIES_CUSTOMER_ID } from '../../../constants/data';
import { defaultDirectiveAdminFilter } from '../../../constants/filters';
import CountryInput from '../fields/CountryInput.vue';
import SnackbarMixin from '../../../mixins/snackbar';

export default {
  name: 'DirectiveAdminsFilter',
  components: { CountryInput },
  props: {
    value: { type: Object, default: () => ({ ...defaultDirectiveAdminFilter }) },
  },
  data: () => ({
    isOpen: [],
  }),
  async mounted() {
    const response = await countryService.findAll();
    if (response) this.setCountries([...response.data]);
  },
  watch: {
    'value.country': function (nValue) {
      this.getSchoolList(nValue);
      // Reset school selection when country changes — the previous school belongs to the old country
      if (this.value.school_id != null) {
        this.$emit('input', { ...this.value, school_id: null });
      }
    },
  },
  methods: {
    ...mapActions('common', ['setCountries', 'setSchoolList']),
    manageInput(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
    async getSchoolList(country) {
      try {
        if (country) {
          const { status, data } = await schoolService.getListByCountry(country);
          if (status === 200) this.setSchoolList([...data]);
          else this.setSchoolList([]);
        } else {
          this.setSchoolList([]);
        }
      } catch (e) {
        this.snackbarError(e.message);
      }
    },
    search() {
      this.$emit('search');
    },
    clearFilter() {
      this.$emit('input', { ...defaultDirectiveAdminFilter });
      this.$emit('search');
    },
  },
  computed: {
    ...mapState({
      countries: ({ common: { countries } }) => countries.filter((country) => COUNTRIES_CUSTOMER_ID.includes(country.id)),
      schoolList: ({ common: { schoolList } }) => schoolList,
    }),
  },
  mixins: [SnackbarMixin],
};
</script>

<style scoped>
.search-btn {
  height: 40px;
  top: -6px;
  width: 180px;
  background: #4b398a;
  color: white;
}
</style>
